export const SET_FILTERS = 'SET_FILTERS';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_SINGLE = 'SET_LOADING_SINGLE';
export const SET_REPROCESSING = 'SET_REPROCESSING';

export const GET_OUTPUT_MAPPINGS = 'GET_OUTPUT_MAPPINGS';
export const GET_OUTPUT_MAPPINGS_SUCCESS = 'GET_OUTPUT_MAPPINGS_SUCCESS';
export const GET_OUTPUT_MAPPINGS_FAILURE = 'GET_OUTPUT_MAPPINGS_FAILURE';

export const REPROCESS_OUTPUT_MAPPINGS = 'REPROCESS_OUTPUT_MAPPINGS';
export const REPROCESS_OUTPUT_MAPPINGS_SUCCESS = 'REPROCESS_OUTPUT_MAPPINGS_SUCCESS';
export const REPROCESS_OUTPUT_MAPPINGS_FAILURE = 'REPROCESS_OUTPUT_MAPPINGS_FAILURE';

export const GET_SINGLE_OUTPUT_MAPPING = 'GET_SINGLE_OUTPUT_MAPPING';
export const GET_SINGLE_OUTPUT_MAPPING_SUCCESS = 'GET_SINGLE_OUTPUT_MAPPING_SUCCESS';
export const GET_SINGLE_OUTPUT_MAPPING_FAILURE = 'GET_SINGLE_OUTPUT_MAPPING_FAILURE';
